import { t, Trans } from '@lingui/macro';
import { quoteItemStatus, TireOfferMinimal } from 'noddi-types';
import { NoddiDummyButton, NoddiIcon } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import { customerRoutes, getCarDisplayName } from 'noddi-util';
import { useNavigate } from 'react-router-dom';
import { TireOfferStatusChip } from '../../components/TireOffer/TireOfferStatusChip';

interface TireOfferStatusCardProps {
  tireSetOffer: TireOfferMinimal;
  setActiveTireSetOfferId: (id: number) => void;
}

export const TireOfferStatusCard = ({ tireSetOffer, setActiveTireSetOfferId }: TireOfferStatusCardProps) => {
  const buttonText = tireSetOffer.status.status === quoteItemStatus.PENDING ? t`View offer` : t`View order`;
  const navigate = useNavigate();

  function handleClick() {
    if (tireSetOffer.status.status === quoteItemStatus.PENDING) {
      setActiveTireSetOfferId(tireSetOffer.id);
    } else {
      navigate(customerRoutes.tireOfferStatus.getPath({ slug: tireSetOffer.slug }));
    }
  }
  return (
    <NoddiBasicCard key={tireSetOffer.slug} onClick={handleClick}>
      <div className='flex flex-col justify-between gap-2'>
        <div className='flex flex-row items-center justify-between gap-1'>
          <div className='flex flex-col'>
            <h6 className='text-3'>
              <Trans>Order reference</Trans>
            </h6>
            <h6 className='font-bold text-5'>{tireSetOffer.slug}</h6>
          </div>

          <TireOfferStatusChip tireOffer={tireSetOffer} />
        </div>
        <div className='flex items-center gap-1'>
          <NoddiIcon name='WheelAngle' />
          <p>{getCarDisplayName(tireSetOffer.car)}</p>
        </div>

        <div className='mt-2 flex justify-end'>
          <NoddiDummyButton size='small' endIcon='ArrowRight'>
            {buttonText}
          </NoddiDummyButton>
        </div>
      </div>
    </NoddiBasicCard>
  );
};
